import styled, { css } from 'styled-components';

const inputBase = css`
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#111827' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#1f2937')};

  &:focus {
    outline: none;
    border-color: #111827;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Description = styled.p`
  margin: 0 0 4px;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
`;

export const TextInput = styled.input`
  ${inputBase}
`;

export const Select = styled.select`
  ${inputBase}
`;

/* Kod przepisuje się ze sporej odległości od tabletu — stąd monospace i rozstrzelenie. */
export const CodeInput = styled.input`
  ${inputBase}
  height: 52px;
  font-family: 'SF Mono', 'Roboto Mono', ui-monospace, monospace;
  font-size: 26px;
  letter-spacing: 0.3em;
  text-align: center;
  text-transform: uppercase;
`;

export const Hint = styled.span`
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const ErrorText = styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  color: #dc2626;
`;

export const GhostButton = styled.button`
  padding: 7px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  padding: 7px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #111827;
  color: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);

  &:hover:not(:disabled) {
    background: #000000;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({ theme }) => (theme.mode === 'dark'
    ? `
    background: #1f2937;
    border-color: #374151;
    &:hover:not(:disabled) { background: #111827; }
  `
    : '')}
`;
